import React from "react";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import "./style.css";
import App from "./App";
import { GlobalStateProvider } from "./components/Context/GlobalStateContext";

const container = document.getElementById('root');
if (!container) {
throw new Error('Root container missing in index.html');
}
const root = createRoot(container);
root.render(
  // <React.StrictMode>
    <BrowserRouter>
     <GlobalStateProvider>
      <App />
      </GlobalStateProvider>
    </BrowserRouter>
  //</React.StrictMode> 
);

